/* eslint-disable no-console */
import React, { useState, useRef, useEffect } from 'react';
import Blockly from './blockly/override';
import { xml2js, json2xml } from 'xml-js';
import usePipelineStore from '../store';
import JSONTree from './JSONTree';

import BlocklyComponent, {
  Block,
  Category,
} from './blockly';

import './blocks/customblocks';
import './generator/generator';

const Columns = () => {
  const simpleWorkspace = useRef(null);
  const [initialXml, setInitialXml] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const { effects, ...state } = usePipelineStore();

  useEffect(() => {
    // eslint-disable-next-line react/prop-types
    const { blocks } = state.showReport;
    if (firstLoad && blocks && blocks.columns) {
      setInitialXml(
        json2xml(state.showReport.blocks.columns, {
          compact: true,
          ignoreComment: true,
          spaces: 4,
        }),
      );
      setFirstLoad(false);
    } else if (state.showReport) {
      setInitialXml(
        '<xml xmlns="http://www.w3.org/1999/xhtml"><block type="columns" x="250" y="50"></block></xml>',
      );
    }
  }, [state.showReport]);

  if (!initialXml) {
    return null;
  }

  const generateCode = async (event) => {
    if (simpleWorkspace && simpleWorkspace.current) {
      const { workspace } = simpleWorkspace.current;
      const dom = Blockly.Xml.workspaceToDom(workspace);
      const xml = Blockly.Xml.domToText(dom);
      try {
        const pipelineJSON = xml2js(xml, { compact: true });
        effects.setBlock('columns', pipelineJSON);

        const block = workspace.getBlockById(event.blockId);
        if (block) {
          const rootBlock = block.getRootBlock();
          if (rootBlock.type === 'columns') {
            if (pipelineJSON.xml) {
              if (!state.results.pipeline) {
                await effects.setResults('pipeline');
              }
              effects.setResults('columns', 'pipeline');
            }
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        <BlocklyComponent
          ref={simpleWorkspace}
          readOnly={false}
          initialXml={initialXml}
          onMove={generateCode}
          onChange={generateCode}
          move={{
            scrollbars: false,
            drag: false,
            wheel: true,
            trashcan: false,
          }}
        >
          <Category name="General" colour={300}>
            <Block type="column" />
          </Category>
        </BlocklyComponent>
        <JSONTree data={state.results.pipeline} />
      </header>
    </div>
  );
};

export default Columns;
